import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GlassCard } from "@kj/design-system";
import { LogIn } from "lucide-react";
import { useAdminAuth } from "../store/adminAuth";

// Pre-launch: hardcoded allow-list + invite code.
// Sprint 3에서 Supabase Auth + Cloudflare Access로 교체.
const ALLOWED = ["wpulnbada@gmail.com"];

export default function LoginPage() {
  const nav = useNavigate();
  const signIn = useAdminAuth((s) => s.signIn);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  function submit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    if (!ALLOWED.includes(email.toLowerCase().trim())) {
      setError("Unauthorized email. Contact privacy@skytolove.com.");
      return;
    }
    // Dev invite code. 프로덕션에서는 서버 OTP로 대체.
    if (code.trim() !== "founding-admin-2026") {
      setError("Invalid invite code.");
      return;
    }
    signIn(email.toLowerCase().trim(), "admin");
    nav("/", { replace: true });
  }

  return (
    <div className="min-h-screen grid place-items-center p-4">
      <GlassCard padding="lg" radius="2xl" className="w-full max-w-sm space-y-4">
        <div className="flex items-center gap-2">
          <LogIn className="h-5 w-5 text-primary-500" />
          <h1 className="text-lg font-semibold">SkyToLove Admin</h1>
        </div>
        <p className="text-sm text-fg-muted">
          관리자 전용. 사전 승인된 이메일과 초대 코드가 필요합니다.
        </p>
        <form className="space-y-3" onSubmit={submit}>
          <input
            type="email"
            placeholder="admin@skytolove.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-xl bg-white/5 border border-white/10 px-4 py-3 text-sm"
            aria-label="email"
          />
          <input
            type="text"
            placeholder="invite code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="w-full rounded-xl bg-white/5 border border-white/10 px-4 py-3 text-sm"
            aria-label="invite code"
          />
          {error && (
            <div className="text-xs text-danger-500 rounded-xl border border-danger-500/40 bg-danger-500/10 px-3 py-2">
              {error}
            </div>
          )}
          <button
            type="submit"
            className="w-full rounded-full bg-primary-500 py-3 text-white font-semibold"
          >
            로그인
          </button>
        </form>
        <p className="text-[11px] text-fg-muted">
          Production에서는 Cloudflare Access + 이메일 OTP로 교체됩니다.
        </p>
      </GlassCard>
    </div>
  );
}
